import React from "react";
import {
  Button,
  InputAdornment,
  MenuItem,
  TextField,
  FormControl,
  FormLabel,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Person3Icon from "@mui/icons-material/Person3";
import PasswordIcon from "@mui/icons-material/Password";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import SchoolIcon from "@mui/icons-material/School";

export default function UserForm({
  formData,
  handleChangeInputUser,
  handleInsertUser,
  isEditing,
  handleUpdateUser,
}) {
  // Handle VIP checkbox changes
  const handleVipChange = (vipItem) => {
    const currentVip = formData.vip || [];
    let newVip;
    if (Array.isArray(currentVip)) {
      if (currentVip.includes(vipItem)) {
        newVip = currentVip.filter((v) => v !== vipItem);
      } else {
        newVip = [...currentVip, vipItem];
      }
    } else {
      newVip = currentVip === vipItem ? [] : [vipItem];
    }
    handleChangeInputUser({
      target: { name: "vip", value: newVip },
    });
  };

  // Handle courses checkbox changes
  const handleCoursesChange = (course) => {
    const currentCourses = formData.courses || [];
    console.log("🚀 ~ handleCoursesChange ~ currentCour:", currentCourses);
    let newCourses;

    if (currentCourses.includes(course)) {
      // Remove course if already selected
      newCourses = currentCourses.filter((c) => c !== course);
    } else {
      // Add course if not selected
      newCourses = [...currentCourses, course];
    }

    handleChangeInputUser({
      target: {
        name: "courses",
        value: newCourses,
      },
    });
  };

  return (
    <div className="p-6 max-w-3xl mx-auto bg-white shadow-lg rounded-lg mb-[50px]">
      <h2 className="text-2xl font-bold text-center mb-6">
        {isEditing
          ? "Cập nhật thông tin người dùng"
          : "Tạo tài khoản người dùng"}
      </h2>
      <div className="mb-5 flex justify-around flex-wrap">
        <TextField
          label="Email *"
          name="email"
          value={formData?.email}
          className="md:w-[300px] w-[100%] lg:mb-0 mb-5 label-text"
          onChange={handleChangeInputUser}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <EmailIcon />
              </InputAdornment>
            ),
          }}
          variant="standard"
        />
        <TextField
          label="Tên người dùng *"
          name="fullName"
          value={formData?.fullName}
          onChange={handleChangeInputUser}
          className="md:w-[300px] w-[100%] label-text"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Person3Icon />
              </InputAdornment>
            ),
          }}
          variant="standard"
        />
      </div>

      <div className="mb-5 flex justify-around flex-wrap">
        <TextField
          label="Password *"
          name="password"
          value={formData?.password}
          className="md:w-[300px] w-[100%] lg:mb-0 mb-5 label-text"
          onChange={handleChangeInputUser}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <PasswordIcon />
              </InputAdornment>
            ),
          }}
          variant="standard"
        />
        <TextField
          select
          label="Role *"
          name="role"
          value={
            formData?.role === 1 ? "Admin" : formData?.role === 0 ? "User" : ""
          }
          onChange={handleChangeInputUser}
          className="label-text md:w-[300px] w-[100%] lg:mb-0 mb-5"
          variant="standard"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <AdminPanelSettingsIcon />
              </InputAdornment>
            ),
          }}
          InputLabelProps={{
            shrink: true,
          }}
        >
          {["Admin", "User"].map((option, key) => (
            <MenuItem key={key} value={option}>
              {option}
            </MenuItem>
          ))}
        </TextField>
      </div>

      {/* Courses Selection */}
      <div className="mb-5 flex justify-center">
        <FormControl component="fieldset" className="w-full max-w-md">
          <FormLabel
            component="legend"
            className="flex items-center gap-2 mb-3"
          >
            <SchoolIcon className="text-blue-600" />
            <span className="text-gray-700 font-medium">
              Khóa học (không bắt buộc)
            </span>
          </FormLabel>
          <FormGroup className="flex flex-row gap-6 justify-center">
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData?.courses?.includes("TSA") || false}
                  onChange={() => handleCoursesChange("TSA")}
                  name="TSA"
                  sx={{
                    color: "#1976d2",
                    "&.Mui-checked": {
                      color: "#1976d2",
                    },
                  }}
                />
              }
              label="TSA"
              className="text-gray-700"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData?.courses?.includes("THPT") || false}
                  onChange={() => handleCoursesChange("THPT")}
                  name="THPT"
                  sx={{
                    color: "#2e7d32",
                    "&.Mui-checked": {
                      color: "#2e7d32",
                    },
                  }}
                />
              }
              label="THPT"
              className="text-gray-700"
            />
          </FormGroup>
        </FormControl>
      </div>

      {/* VIP Selection */}
      <div className="mb-5 flex justify-center">
        <FormControl component="fieldset" className="w-full max-w-md">
          <FormLabel component="legend" className="text-gray-700 font-medium mb-3">
             <span className="inline-flex items-center px-3 py-1 rounded-full text-base font-semibold bg-gradient-to-r from-yellow-400 to-amber-500 text-white shadow-lg">
                <svg
                  className="w-6 h-6 mr-[2px]"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M5 12l2-5 3 3 3-3 2 5 4-3-3 10H4L1 9l4 3z" />
                </svg>
                VIP
              </span>
          </FormLabel>
          <FormGroup className="flex flex-row gap-6 justify-center">
            {["VIP1", "VIP2", "VIP3", "VIP4"].map((vipItem) => (
              <FormControlLabel
                key={vipItem}
                control={
                  <Checkbox
                    checked={
                      Array.isArray(formData?.vip)
                        ? formData.vip.includes(vipItem)
                        : formData?.vip === vipItem
                    }
                    onChange={() => handleVipChange(vipItem)}
                    name={vipItem}
                    sx={{
                      color: "#d32f2f",
                      "&.Mui-checked": { color: "#d32f2f" },
                    }}
                  />
                }
                label={vipItem.replace("VIP", "VIP ")}
                className="text-gray-700"
              />
            ))}
          </FormGroup>
        </FormControl>
      </div>

      <div className="mb-5 flex justify-around flex-wrap px-[130px]">
        {isEditing ? (
          <Button
            variant="contained"
            component="label"
            className="label-text md:w-[250px] w-[100%] py-[10px]"
            startIcon={<CloudUploadIcon />}
            onClick={handleUpdateUser}
          >
            Cập nhật tài khoản
          </Button>
        ) : (
          <Button
            variant="contained"
            component="label"
            className="label-text md:w-[200px] w-[100%] py-[10px]"
            startIcon={<CloudUploadIcon />}
            onClick={handleInsertUser}
          >
            Tạo tài khoản
          </Button>
        )}
      </div>
    </div>
  );
}
